module.exports = __webpack_public_path__ + "img/cog.1ddbcf59.png";